export default __webpack_public_path__ + "static/media/cli-arcelor.45d10f6c.jpg";